<template>
    <b-card title="Filtros" class="d-print-none">
        <b-card-text>
            <b-row>
                <b-col cols="12" md="5" v-if="!isClientUser">
                    <app-autocomplete
                        placeholder="Cliente"
                        :items="clients"
                        v-model="theClient"
                    />
                </b-col>
                <b-col cols="12" md="2">
                    <app-years-select-input
                        :label="false"
                        :placeholder="true"
                        v-model="filters.year"
                    />
                </b-col>
                <b-col cols="12" md="2">
                    <app-months-select-input v-model="filters.month" :label="false" :placeholder="true" />
                </b-col>
                <b-col cols="12" md="3">
                    <b-button variant="primary" :disabled="!validFilters" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    <b-button variant="primary" :disabled="!validFilters" @click="print"><i class="fa fa-print"></i></b-button>
                </b-col>
            </b-row>
        </b-card-text>
    </b-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import reportingRepository from '@repositories/reporting.repository';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    data(){
        return {
            filters: {
                clientId: '',
                year: '',
                month: ''
            },
            theClient: {}
        }
    },
    computed: {
        ...mapGetters(['clients', 'client']),
        isClientUser() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
        validFilters(){
            const keysToValidate = this.isClientUser 
                ? Object.keys(this.filters).filter(key => key !== 'clientId')
                : Object.keys(this.filters);
            return !keysToValidate.filter(key => !this.filters[key]).length;
        }
    },
    watch: {
        theClient(val){
            if (val && val.id) {
                this.filters.clientId = val.id;
            }
        }
    },
    methods: {
        print(){
            const rr = {...reportingRepository};
            const clientId = this.isClientUser && this.client 
                ? this.client.id 
                : this.filters.clientId;
            rr.registerManagementReportDownload({
                clientId: clientId,
                year: this.filters.year,
                month: this.filters.month
            });
            window.print();
        }
    },
    created() {
        if (this.isClientUser && this.client) {
            this.theClient = this.client;
            this.filters.clientId = this.client.id;
        }
    },
}
</script>